'use client'

import i18n from 'i18next'
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

const getLanguageFromCookie = (): 'ko' | 'en' | 'zh-CN' | 'zh-TW' | 'jp' => {
  if (typeof window !== 'undefined') {
    const match = document.cookie.match(/lang=([^;]+)/)
    if (match) {
      const lang = match[1]
      if (['en', 'ko', 'zh-CN', 'zh-TW', 'jp'].includes(lang)) {
        return lang as 'en' | 'ko' | 'zh-CN' | 'zh-TW' | 'jp'
      }
    }
  }
  return 'ko'
}

if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .use(HttpApi)
    .init({
      lng: getLanguageFromCookie(),
      supportedLngs: ['en', 'ko', 'zh-CN', 'zh-TW', 'jp'],
      interpolation: { escapeValue: false },
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json'
      },
      ns: ['home', 'notice', 'faq', 'contact'],
      defaultNS: 'home'
    })
}

export default i18n
